<script lang="ts" setup>
import type { TagProps, } from "element-plus"
import type { VNode, } from "vue"
import { tagEmits, useFormSize, useNamespace, } from "element-plus"

defineOptions({
  name: "ElTag",
},)
const props = withDefaults(defineProps<TagProps>(), {
  type: "primary",
  effect: "light",
},)
const emit = defineEmits(tagEmits,)

const tagSize = useFormSize()
const ns = useNamespace("tag",)
const containerKls = computed(() => {
  const { type, hit, effect, closable, round, } = props
  return [
    ns.b(),
    ns.is("closable", closable,),
    ns.m(type || "primary",),
    ns.m(tagSize.value,),
    ns.m(effect,),
    ns.is("hit", hit,),
    ns.is("round", round,),
  ]
},)

// methods
function handleClose(event: MouseEvent,) {
  emit("close", event,)
}

function handleClick(event: MouseEvent,) {
  emit("click", event,)
}

function handleVNodeMounted(vnode: VNode,) {
  // @ts-expect-error unknown
  if (vnode?.component?.subTree?.component?.bum) {
    // @ts-expect-error unknown
    vnode.component.subTree.component.bum = null
  }
}
</script>

<template>
  <span
    v-if="disableTransitions"
    :class="containerKls"
    :style="{ backgroundColor: color }"
    @click="handleClick"
  >
    <ElText :class="ns.e('content')" class="h-full !font-size-inherit !color-inherit" truncated>
      <slot />
    </ElText>
    <Icon
      v-if="closable"
      :class="ns.e('close')"
      icon="ep:close"
      @click.stop="handleClose"
    />
  </span>
  <Transition
    v-else
    :name="`${ns.namespace.value}-zoom-in-center`"
    appear
    @vue:mounted="handleVNodeMounted"
  >
    <span
      :class="containerKls"
      :style="{ backgroundColor: color }"
      @click="handleClick"
    >
      <ElText :class="ns.e('content')" class="h-full !font-size-inherit !color-inherit" truncated>
        <slot />
      </ElText>
      <Icon
        v-if="closable"
        :class="ns.e('close')"
        icon="ep:close"
        @click.stop="handleClose"
      />
    </span>
  </Transition>
</template>
